import { connect } from "react-redux";
import { provideHooks } from "redial";
import {
  getCategoryBreadcrumbs,
  getCategoryError,
  setCategoryError
} from "../../state/modules/category";
import {
  getTitle,
  getListOfBrands
} from "../../state/modules/brands/selectors";
import {
  loadCategoryDetails,
  loadCategory
} from "../../state/modules/category/actions/loadCategoryDetails";
import { fetchBrands } from "../../state/modules/brands/actions";
import undoSearch from "../../state/modules/search/undo/actions";
import { setPageLoading, setIsNewPage } from "../../state/modules/page/actions";
import { analyticsPageLoad } from "../../state/modules/analytics/actions";
import BrandsPageContainer from "./BrandsPage";
import { queryStringToObject } from "../../helpers/queryStringToObject";

const mapStateToProps = state => ({
  title: getTitle(state),
  groups: getListOfBrands(state),
  categoryError: getCategoryError(state),
  breadcrumbs: getCategoryBreadcrumbs(state)
});

export const hooks = {
  fetch: ({ dispatch, location, store, uuid, xSiteOrigin, isNewPage }) => {
    const query = queryStringToObject(location?.search);
    const state = store.getState();
    const {
      config: {
        country,
        locale: { language }
      }
    } = state;

    return Promise.all([
      dispatch(undoSearch()),
      dispatch(
        fetchBrands({
          country,
          query,
          uuid,
          xSiteOrigin
        })
      ),
      dispatch(
        loadCategoryDetails({
          country,
          language,
          query,
          uuid,
          xSiteOrigin
        })
      ),
      dispatch(
        loadCategory({
          query,
          country,
          language,
          uuid,
          xSiteOrigin
        })
      )
    ])
      .catch(error => dispatch(setCategoryError(error)))
      .finally(() => {
        dispatch(setPageLoading(false));
        if (isNewPage) {
          dispatch(analyticsPageLoad());
          dispatch(setIsNewPage(false));
        }
      });
  }
};

export default provideHooks(hooks)(
  connect(mapStateToProps)(BrandsPageContainer)
);
